import { CssBaseline, ThemeProvider } from "@mui/material";
import React, { useContext, useEffect } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useNavigate,
} from "react-router-dom";
import "./components/css/App.css";
import AccountMaintenance from "./screens/Account Maintenance/AccountMaintenance";
import AddFuelMeterData from "./screens/Add Fuel Meter/AddFuelMeterData";
import FBOHome from "./screens/FBO Home/FBOHome";
import FuelRoyaltyHome from "./screens/FBO Home/Fuel Royalty Home/FuelRoyaltyHome";
import LandLeaseHome from "./screens/FBO Home/Land Lease Home/LandLeaseHome";
import LandingFeeHome from "./screens/FBO Home/Landing Fee Home/LandingFeeHome";
import FBOLandingFee from "./screens/FBO Landing Fee/FBOLandingFee";
import CreateFlightPlan from "./screens/FBO Landing Fee/Views/CreateFlightPlan";
import Invoices from "./screens/Invoices/Invoices";
import ViewInvoice from "./screens/Invoices/View Invoice/ViewInvoice";
import ViewFuelRoyaltySubmittedData from "./screens/View Fuel Royalty Submitted Data/ViewFuelRoyaltySubmittedData";
import ROUTE_PATHS from "./utils/routePaths";
import theme from "./utils/theme";
import NotificationsScreen from "./screens/Notifications/NotificationsScreen";
import { StorageContext } from "./services/StorageProvider";
import Loader from "./components/element/Loader";
import PageNotFound from "./components/element/PageNotFound";
import FboPaymentScreen from "./screens/FBO Home/FBO Payment/FboPaymentScreen";
import { FBO_ROLE_CODES } from "./utils/constants";

const AssociationsBasedRedirect = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const existingPath = sessionStorage.getItem("initialPath");
    if (!existingPath) {
      navigate(ROUTE_PATHS.FBO_HOME, { replace: true });
      sessionStorage.setItem("initialPath", ROUTE_PATHS.FBO_HOME);
    }
  }, []);

  return children;
};

const App = () => {
  const { fboUserProfileData } = useContext(StorageContext);
  const hasAdminAccess = fboUserProfileData?.associations?.some(
    (association) => association?.role === FBO_ROLE_CODES.FBO_ADMIN
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AssociationsBasedRedirect>
          {fboUserProfileData ? (
            <Routes>
              <Route
                path={ROUTE_PATHS.HOME}
                element={<Navigate to={ROUTE_PATHS.FBO_HOME} replace />}
              />
              <Route path={ROUTE_PATHS.FBO_HOME} element={<FBOHome />} />
              <Route
                path={ROUTE_PATHS.FUEL_ROYALTY_HOME}
                element={<FuelRoyaltyHome />}
              />
              <Route
                path={ROUTE_PATHS.AIRPORT_BASED_OPERATORS_HOME}
                element={<LandLeaseHome />}
              />
              <Route
                path={ROUTE_PATHS.LANDING_FEE_HOME}
                element={<LandingFeeHome />}
              />
              <Route
                path={ROUTE_PATHS.LANDING_FEE_DATA}
                element={<FBOLandingFee />}
              />
              <Route
                path={ROUTE_PATHS.CREATE_FLIGHT_PLAN}
                element={<CreateFlightPlan />}
              />
              <Route path={ROUTE_PATHS.INVOICES} element={<Invoices />} />
              <Route
                path={ROUTE_PATHS.VIEW_INVOICES}
                element={<ViewInvoice />}
              />
              <Route
                path={ROUTE_PATHS.ACCOUNT_MAINTENANCE}
                element={
                  hasAdminAccess ? <AccountMaintenance /> : <PageNotFound />
                }
              />
              <Route
                path={ROUTE_PATHS.ADD_FUEL_METER}
                element={<AddFuelMeterData />}
              />
              <Route
                path={ROUTE_PATHS.VIEW_SUBMITTED_FUEL_READING}
                element={<ViewFuelRoyaltySubmittedData />}
              />
              <Route
                path={ROUTE_PATHS.NOTIFICATIONS}
                element={<NotificationsScreen />}
              />
              <Route
                path={ROUTE_PATHS.PAYMENTS}
                element={<FboPaymentScreen />}
              />
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          ) : (
            <Loader />
          )}
        </AssociationsBasedRedirect>
      </Router>
    </ThemeProvider>
  );
};

export default App;
